import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { StorageService } from 'src/app/services/common/storage';
import { AppState, selectAuthState } from 'src/app/store/app.states';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-vendor-certification-etraining',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public state: any;
  public isAuthenticated: any;
  constructor(private meta: Meta,
    private titleService: Title, private localStorage: StorageService, private store: Store<AppState>) { }

  ngOnInit(): void {

    this.store.select(selectAuthState).subscribe((state) => {
      this.state = state;
      if (state) {
        this.isAuthenticated = state["user"].isAuthenticated;
      }

    });

    this.titleService.setTitle('Bienvenue au Centre de Formation Apostolique(CFA)');
    this.meta.addTags([
      {
        name: 'description',
        content: 'Le CFA a pour objectif de produire des serviteurs de Dieu de qualité, conscients de leur identité en Christ et qui prennent position face à un monde de plus en plus incertain et complexe.'
      },
      {
        name: 'keywords',
        content: 'Apostolique, cfa, biblique, école, formation, disciples ',
      },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'digitrium' },
      { charset: 'UTF-8' },
    ]);
  }
}